import {AbstractAdminEntityService} from "../../admin/AbstractAdminEntityService";
import {ListPayoutStructureResponse, PayoutStructure} from "../../../../generated/protocol";
import {AdminEntityService} from "../../admin/AdminEntityService";
import {injectable} from "inversify";


export interface PayoutStructureService extends AdminEntityService<PayoutStructure> {


}

@injectable()
export class PayoutStructureServiceImpl extends AbstractAdminEntityService<PayoutStructure, ListPayoutStructureResponse> implements PayoutStructureService {


    constructor() {
        super("/poker/tournament-structures/payouts");
    }

}


// WEBPACK FOOTER //
// ./src/app/service/poker/tournament/PayoutStructureService.ts